import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

import Card from '../../../components/Card';
import CardHeader from '../../../components/CardHeader';
import IndicatorBox from '../../../components/IndicatorBox';
import { I18n } from 'react-redux-i18n';

const AuctionIndicatorsContainer = styled.div`
  > * {
    height: calc(100% - 60px);
  }

  .auctionIndicatorsContainer {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
    width: 100%;
  }
`;

const AuctionIndicators = ({ data, currency = 'EUR' }) => (
  <AuctionIndicatorsContainer>
    <Card>
      <CardHeader
        title={I18n.t('auction.auction.indicators.title')}
        fontSize="24px"
        alignItems="center"
        // TODO: API ROUTE XLS NOT AVAILABLE DONT TOUCH
        // rightComponents={<ExportButton xls />}
      />
      <div className="auctionIndicatorsContainer">
        <IndicatorBox
          title={data.total_bottles}
          content={I18n.t('auction.auction.indicators.nbBottles')}
        />
        <IndicatorBox
          title={data.total_sales}
          content={I18n.t('auction.auction.indicators.nbSales')}
        />

        <IndicatorBox
          title={
            <React.Fragment>
              {data[
                currency === data.displayed_currency
                  ? 'min_price'
                  : 'min_local_price'
              ].toLocaleString('fr-FR', {
                style: 'currency',
                currency:
                  currency === data.displayed_currency
                    ? data.displayed_currency
                    : data.local_currency,
                minimumFractionDigits: 0,
                maximumFractionDigits: 2
              })}
              <span>{I18n.t('auction.auction.indicators.ttc')}</span>
            </React.Fragment>
          }
          content={
            <div>
              <p>{I18n.t('auction.auction.indicators.minPrice')}</p>
              <p style={{ opacity: 0.5 }}>{`(${data.wine_name} ${
                data.min_vintage
              } - ${data.min_store}, ${moment(data.min_date).format(
                'DD/MM/YYYY'
              )})`}</p>
            </div>
          }
        />
        {data['avg_price'] || data['avg_local_price'] ? (
          <IndicatorBox
            title={
              <React.Fragment>
                {data[
                  currency === data.displayed_currency
                    ? 'avg_price'
                    : 'avg_local_price'
                ].toLocaleString('fr-FR', {
                  style: 'currency',
                  currency:
                    currency === data.displayed_currency
                      ? data.displayed_currency
                      : data.local_currency,
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2
                })}
                <span>{I18n.t('auction.auction.indicators.ttc')}</span>
              </React.Fragment>
            }
            content={
              <div>
                <p>{I18n.t('auction.auction.indicators.avgPrice')}</p>
                <p style={{ opacity: 0.5 }}>
                  {I18n.t('auction.auction.indicators.avgPriceSubText')}{' '}
                </p>
              </div>
            }
          />
        ) : data['avg_price_champ'] || data['avg_local_price_champ'] ? (
          <IndicatorBox
            title={
              <React.Fragment>
                {data[
                  currency === data.displayed_currency
                    ? 'avg_price_champ'
                    : 'avg_local_price_champ'
                ].toLocaleString('fr-FR', {
                  style: 'currency',
                  currency:
                    currency === data.displayed_currency
                      ? data.displayed_currency
                      : data.local_currency,
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2
                })}
                <span>{I18n.t('auction.auction.indicators.ttc')}</span>
              </React.Fragment>
            }
            content={
              <div>
                <p>{I18n.t('auction.auction.indicators.avgPrice')}</p>
                <p style={{ opacity: 0.5 }}>
                  {I18n.t('auction.auction.indicators.avgPriceSubTextNv')}{' '}
                </p>
              </div>
            }
          />
        ) : (
          ''
        )}
      </div>
    </Card>
  </AuctionIndicatorsContainer>
);

export default AuctionIndicators;
